import { toast } from 'react-toastify';
import _ from 'lodash';

export const showToast = (content: string, type?: string) => {
  let isToastHelperVisible = false;

  if (type === 'success') {
    toast.success(content, {
      position: 'bottom-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    return;
  }

  if (type === 'error') {
    toast.error(_.capitalize(content), {
      position: 'bottom-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    return;
  }

  if (type === 'errorInfo') {
    if (isToastHelperVisible) {
      return;
    }

    toast.error(content, {
      position: 'bottom-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      onOpen: () => {
        isToastHelperVisible = true;
      },
      onClose: () => {
        isToastHelperVisible = false;
      },
    });
    return;
  }

  toast(content, {
    position: 'bottom-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};
